import { Component, OnInit, ViewChild,Output,EventEmitter,Input,AfterContentInit } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { NgbActiveModal, NgbTypeahead , NgbDate} from '@ng-bootstrap/ng-bootstrap';
import {Observable, Subject, merge, OperatorFunction} from 'rxjs';
import {debounceTime, distinctUntilChanged, filter, map} from 'rxjs/operators';
import { SubCategoriesService,CompaniesService,AuthService, CandidatesService, SkillsService } from '../../../../services';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-professional-experience-modal',
    templateUrl: './professional-experience-modal.html',
    styleUrls: ['./professional-experience-modal.scss']
})

export class ProfessionalExperienceModalComponent implements OnInit, AfterContentInit  {
    @ViewChild('instanceCat', {static: false}) instance: NgbTypeahead;
    @ViewChild('instanceComp', {static: false}) _instance: NgbTypeahead;
    @ViewChild('instanceSkill', {static: false}) skill_instance: NgbTypeahead;
    @Output() notifyParent = new EventEmitter<any>();
    @Input() isEdit  = false;
    @Input() porfExp = {
        id: null,
        start_date : null,
        end_date : null,
        company  : null,
        company_id : null,
        company_name : null,
        sub_category: null,
        sub_category_id : null,
        company_location : null,
        company_website : null,
        job_title : null,
        duties : null,
        is_present : false,
        skills : []
    }

    sub_categories = [];
    companies      = [];
    skills         = [];
    isLoading      = false;
    _maxDate       = new Date();
    maxDate        = {year: this._maxDate.getFullYear() , month: this._maxDate.getMonth()+1, day: this._maxDate.getDate()}
    skill_object   = null;
    constructor(private toastr :ToastrService,private skillService: SkillsService,private candidatesService: CandidatesService,private authService: AuthService, private location: PlatformLocation,public activeModal: NgbActiveModal, private subCat: SubCategoriesService, private companySer: CompaniesService) {
    	location.onPopState(() => { this.activeModal.close();});
    }

    ngAfterContentInit () {
        if(this.isEdit && this.porfExp.start_date){
            const temp1 = new Date(this.porfExp.start_date)
            this.porfExp.start_date = {year:temp1.getFullYear(),month:temp1.getMonth()+1,day:temp1.getDate()};
        }
        if(this.isEdit && this.porfExp.end_date){
            const temp2 = new Date(this.porfExp.end_date)
            this.porfExp.end_date   = {year:temp2.getFullYear(),month:temp2.getMonth()+1,day:temp2.getDate()};
        }
    }

    ngOnInit() {
        this.subCat.getAll().subscribe((res: any) =>{this.sub_categories = res.data;});
        this.companySer.getAll().subscribe((res: any) =>{this.companies = res.data;});
        this.skillService.getAll().subscribe((res: any) =>{this.skills = res.data;});
    }

    closeModal(){
    	this.activeModal.close({status:true});
    }

    canAdd(){
        return this.isLoading || (this.porfExp.start_date == null || this.porfExp.job_title == null || this.porfExp.duties == null || ( this.porfExp.end_date == null && !this.porfExp.is_present ) );
    }

    updateUserProfile(){
        this.porfExp.company_id = this.porfExp.company?.id
        this.porfExp.sub_category_id = this.porfExp.sub_category?.id

        var _prof = Object.assign({},this.porfExp);
        _prof.start_date = this.porfExp.start_date.year+"-"+this.porfExp.start_date.month+"-"+this.porfExp.start_date.day
        if(!this.porfExp.is_present)
            _prof.end_date = this.porfExp.end_date.year+"-"+this.porfExp.end_date.month+"-"+this.porfExp.end_date.day
        else
            _prof.end_date = null;
        this.isLoading = true;
        if(!this.isEdit)
            this.candidatesService.addProfExp(_prof,this.authService.user.candidate?.id).subscribe((res: any) =>{
                this.isLoading = false;
                this.porfExp = {
                    id: null,
                    start_date : null,
                    end_date : null,
                    company  : null,
                    company_id : null,
                    company_name : null,
                    sub_category: null,
                    sub_category_id : null,
                    company_location : null,
                    company_website : null,
                    job_title : null,
                    duties : null,
                    is_present : false,
                    skills : []
                };
                this.notifyParent.emit(true);
                this.closeModal();
            },(error)=>{
                this.isLoading = false;
                this.toastr.error("Something wrong, try again later", "Add Professional Experience");
            });
        else
            this.candidatesService.updateProfExp(_prof,this.authService.user.candidate?.id,this.porfExp.id).subscribe((res: any) =>{
                this.isLoading = false;
                this.porfExp = res.data;
                this.notifyParent.emit(true);
                this.closeModal();
            },(error)=>{
                this.isLoading = false;
                this.toastr.error("Something wrong, try again later", "Update Professional Experience");
            });
    }

    formatter = (sub_category: any) => sub_category.sub_category_name_en;
    focus$ = new Subject<string>();
    click$ = new Subject<string>();
    search: OperatorFunction<string, readonly {id, sub_category_name_en}[]> = (text$: Observable<string>) => {
        text$.pipe(debounceTime(200),distinctUntilChanged());
        const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
        const clicksWithClosedPopup$ = this.click$.pipe(filter(() => !this.instance.isPopupOpen()));
        const inputFocus$ = this.focus$;

        return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(map(term => (term === '' ? this.sub_categories.slice(0,10)
        : this.sub_categories.filter(sub_category => new RegExp(term, 'mi').test(sub_category.sub_category_name_en) || new RegExp(term, 'mi').test(sub_category.sub_category_name_ar)).slice(0, 10)))
    )}


    _formatter = (company: any) => company.company_name_en || company;
    _focus$ = new Subject<string>();
    _click$ = new Subject<string>();
    _search: OperatorFunction<string, readonly {id, company_name_en}[]> = (text$: Observable<string>) => {
        text$.pipe(debounceTime(200),distinctUntilChanged());
        const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
        const clicksWithClosedPopup$ = this._click$.pipe(filter(() => !this._instance.isPopupOpen()));
        const inputFocus$ = this._focus$;
        //text$.pipe().subscribe(value => this.porfExp.company_name = value);

        return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(map(term => (term === '' ? this.companies.slice(0,10)
        : this.companies.filter(company => new RegExp(term, 'mi').test(company.company_name_en) || new RegExp(term, 'mi').test(company.company_name_ar)).slice(0, 10)))
    )}

    selectCompany(){
        this.porfExp.company_name     = (typeof this.porfExp.company == 'string') ? this.porfExp.company : null;
        this.porfExp.company_location = this.porfExp.company.company_location;
        this.porfExp.company_website  = this.porfExp.company.company_website;
    }

    skill_formatter = (skill: any) => skill.skill_name_en;
    skill_focus$ = new Subject<string>();
    skill_click$ = new Subject<string>();
    skill_search: OperatorFunction<string, readonly {id, skill_name_en}[]> = (text$: Observable<string>) => {
        text$.pipe(debounceTime(200),distinctUntilChanged());
        const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
        const clicksWithClosedPopup$ = this.skill_click$.pipe(filter(() => !this.skill_instance.isPopupOpen()));
        const inputFocus$ = this.skill_focus$;

        return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(map(term => (term === '' ? this.skills.slice(0,10)
        : this.skills.filter(skill => new RegExp(term, 'mi').test(skill.skill_name_en)).slice(0, 10)))
    )}

    addNewSkill(){
        if(this.skill_object){
            for (var i = 0; i < this.porfExp.skills.length; i++) {
                if(this.porfExp.skills[i].id == this.skill_object.id)
                    return;
            }
            this.porfExp.skills.push(this.skill_object);
            this.skill_object = null;
        }
    }

    removeSkill(i){
        this.porfExp.skills.splice(i,1);
    }

    resetDate(){
        this.porfExp.end_date = null;
    }
}